import axios from "axios";

function loadEnum(name) {
  return {
    [name]: ({ enums }) => {
      const data = enums?.[name] ?? [];
      return data.map(({ id, name }) => ({ id, value: name }));
    },
  };
}

export default {
  namespaced: true,
  state: {
    enums: {},
  },
  getters: {
    ...loadEnum("purchase_type"),
    ...loadEnum("employee_type"),
    ...loadEnum("period_sale_type"),
    ...loadEnum("expense_type"),
    ...loadEnum("medicine_type"),
    ...loadEnum("treatment_plan_type"),
  },
  mutations: {
    SET_ENUMS: (state, enums) => (state.enums = enums),
  },
  actions: {
    async initialize({ commit }) {
      const { data } = (await axios.get("types")).data;
      commit("SET_ENUMS", data);
    },
  },
};
